// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppButton_whatsappButton__3KMti","whatsappIcon":"WhatsAppButton_whatsappIcon__o-30j","pulse":"WhatsAppButton_pulse__eKu-Y"};